import {makeStyles} from "@material-ui/core";
import {baseTableCellStyles, baseTableFooterStyles, baseTableRowStyles} from "../shared/sharedTableStyles";

const styles = theme => ({
  totalAmountInputRoot: {
    marginBottom: 0,
    height: 40
  },
  accordionPortfolioRoot: {
    boxShadow: '0px 3px 15px #00000033',
    borderRadius: '5px 5px 0px 0px !important',
    width: '100%',
    '&.Mui-expanded': {
      margin: 0,
    }
  },
  totalAmount: {
    fontFamily: 'Roboto-Bold',
    fontSize: 16,
    padding: '16px 64px 16px 28px',
    background: '#D8DCDF',
    boxShadow: '0px 3px 15px #00000033',
    borderRadius: '0px 0px 5px 5px',
    zIndex: 0,
    '& > .MuiGrid-item': {
      paddingLeft: 5,
      paddingRight: 5,
      '&:last-child': {
        marginLeft: 'auto',
      }
    },
  },
  accordionRoot: {
    boxShadow: 'none',
    border: '1px solid #D8DCDF',
    borderRadius: 5,
    width: '100%',
    margin: '5px 0 !important',
  },
  accordionPortfolioHeader: {
    fontFamily: "Roboto-Medium",
    padding: "2px 33px 2px 20px",
    fontSize: 20,
    backgroundColor: "#394352",
    color: "#fff",
    '&.Mui-expanded': {
      minHeight: 'auto',
    },
    '& .MuiAccordionSummary-content': {
      alignItems: 'center',
      '&.Mui-expanded': {
        margin: '12px 0',
      }
    },
  },
  accordionHeader: {
    fontFamily: 'Roboto-Bold',
    fontSize: 16,
    padding: "2px 16px",
    '&.Mui-expanded': {
      minHeight: 'auto',
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: '12px 0',
    },
    '&.Mui-focused': {
      background: 'white !important'
    }
  },
  accordionDetails: {
    flexDirection: 'column',
  },
  tableCell: {
    ...baseTableCellStyles,
    '&:last-child': {
      textAlign: 'center',
      width: 50,
    },
  },
  addBtnContainer: {
    display: 'flex',
    padding: '1rem 0',
    '& .Mui-error': {
      fontSize: 14,
      fontFamily: 'Roboto-Regular',
    }
  },
  header: {
    height: 16,
  },
  closeButton: {
    position: 'absolute',
    top: 3,
    right: 10
  },
  dialogActions: {
    padding: 24,
  },
  small: {
    fontSize: "80%",
  },

  depotTypeSection: {
    marginTop: 5
  },
  depotSelection:{
    padding: '12px 12px 12px 0'
  },
  depotSelectionInput: {
    backgroundColor: 'white',
    marginBottom: 0
  },
  depotTypeDescriptionLine: {
    margin: 0,
    padding: 0,
    fontSize: 12
  },
  depotOverall: {
    marginLeft: 'auto',
    textAlign: 'right',

    '& > p': {
      margin: 0
    }
  },
  tableRow: {
    ...baseTableRowStyles
  },
  tableFooter: {
    ...baseTableFooterStyles,
  },
  tableTitle: {
    fontFamily: 'Roboto-Bold',
    fontSize: 18,
  },
  tableContainer: {
    overflowX: 'auto'
  }
});

export const useStyles = makeStyles(styles)

export default styles;
